import { Documents } from '@/core/domain/official-documents/models/official-documents.model';
import { OfficialDocumentsRepository } from '@/core/domain/official-documents/repositories/official-documents.repository';
import { updatePrecheckin } from '@/core/reservation/store/precheckin.actions';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OfficialDocumentsImplRepository extends OfficialDocumentsRepository {
    constructor(private readonly store: Store) {
        super();
    }

    override storeDocuments(documentsData: Documents): Observable<boolean> {
        this.store.dispatch(
            updatePrecheckin({
                value: documentsData,
            }),
        );
        return of(true);
    }
}
